<template>
  <div class="user--notifications" v-bind:class="{ opened: isActive }">
    <a @click="isActive = !isActive;" href="#"
        aria-haspopup="true" :aria-expanded="isActive == true">
        <i class="fas fa-bell"></i>
        <div v-if="this.notifications.length" class="notify">{{this.notifications.length}}</div>
    </a>
    <div class="notification--list" v-bind:class="{ visible: isActive }">
      <div v-for="notification in notifications" v-if="notifications.length" class="single--notification">
        <a :href="notification.url_action">
          <h5>{{ notification.title }}</h5>
          <span>{{ notification.content }}</span>
          </a>
          <div v-if="!notifications.length">
              <a href="#" class="border-bottom d-block text-decoration-none py-2 px-3">
                  There are no notifications here..
              </a>
          </div>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        mounted() {
        },

        data()  {
          return {
            isActive: false,
            notifications: []
          }
        },

        methods: {
            getNotifications() {
                axios.get('/me/get-notifications')
                .then(response => (this.notifications = response.data));
            }
        },
        created: function () {
           this.getNotifications();
        }
    }
</script>
